import React from "react";
import ModalButtons from "../ModalButtons/ModalButtons";
import Tabs from "../Tabs/Tabs";
import RoomTypeBuilderErrors from "./RoomTypeBuilderErrors";
import RoomTypeBuilderWorkspace from "./RoomTypeBuilderWorkspace";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import ErrorHelper from "../Errors/ErrorHelper";
import { parseISO } from "date-fns";

class RoomTypeBuilder extends React.Component {
  constructor(props) {
    super(props);

    var rooms;
    this.props.rooms && this.props.rooms.length
      ? (rooms = this.props.rooms.map((room) => room.id))
      : (rooms = []);

    var room_type_prices;
    this.props.room_type_prices && this.props.room_type_prices.length
      ? (room_type_prices = this.props.room_type_prices.map(
          (room_type_price) => {
            if (room_type_price.start_date) {
              room_type_price.start_date = parseISO(room_type_price.start_date);
            }
            return room_type_price;
          }
        ))
      :(room_type_prices = [])

    var property = this.props.property || {};

    var room_groups;
    this.props.room_groups && this.props.room_groups.length
      ? (room_groups = this.props.room_groups.map(
          (room_group) => room_group.id
        ))
      : (room_groups = []);

    var image_group_ids;
    this.props.image_group && this.props.image_group.images.length
      ? (image_group_ids = this.props.image_group.images.map(
          (image) => image.id
        ))
      : (image_group_ids = []);

    var rates;
    this.props.rates && this.props.rates.length
      ? (rates = this.props.rates.map((rate) => rate.id))
      : (rates = []);

    var bedrooms;
    this.props.bedrooms && this.props.bedrooms.length
      ? (bedrooms = this.props.bedrooms.map((bedroom) => bedroom.id))
      : (bedrooms = []);

    var products;
    this.props.products && this.props.products.length
      ? (products = this.props.products.map((product) => product.id))
      : (products = []);

    this.state = {
      /* ui state */
      active_tab: "general",
      loading: false,
      current_date: parseISO(this.props.current_date),
      // /* errors */
      errors: this.props.errors ? this.props.errors : {},
      // id: this.props.id,

      // /* room_type paths */
      room_type_save_path: this.props.room_type_save_path,
      room_type_create_path: this.props.room_type_create_path,
      room_type_image_group_path: this.props.room_type_image_group_path,
      room_type_prices_data_table_path:
        this.props.room_type_prices_data_table_path,
      room_type_incidental_deposit_path:
        this.props.room_type_incidental_deposit_path,
      room_type_price_path: this.props.room_type_price_path,

      /* fields */
      code: this.props.code ? this.props.code : "",
      name: this.props.name ? this.props.name : "",
      description: this.props.description ? this.props.description : "",
      ru_description: this.props.ru_description ? this.props.ru_description : "",
      room_size: this.props.room_size ? this.props.room_size : "",
      room_size_unit: this.props.room_size_unit ? this.props.room_size_unit : "sq2",
      days_before_arrival: this.props.days_before_arrival
        ? this.props.days_before_arrival
        : 0,
      space: this.props.space ? this.props.space : "",
      access: this.props.access ? this.props.access : "",
      interaction: this.props.interaction ? this.props.interaction : "",
      house_rules: this.props.house_rules ? this.props.house_rules : "",
      how_to_arrive: this.props.how_to_arrive ? this.props.how_to_arrive : "",
      bed_types: this.props.bed_types ? this.props.bed_types : [],
      address_1: this.props.address_1 ? this.props.address_1 : '',
      address_2: this.props.address_2 ? this.props.address_2 : '',
      city: this.props.city ? this.props.city : '',
      state: this.props.state ? this.props.state : '',
      country: this.props.country ? this.props.country : '',
      postal_code: this.props.postal_code ? this.props.postal_code : '',
      licence_number: this.props.licence_number ? this.props.licence_number : '',
      property_type_id: this.props.property_type
        ? this.props.property_type.id
        : null,
      color: this.props.color ? this.props.color : "",
      status: this.props.status ? this.props.status : "disabled",
      order: this.props.order || [],
      housekeeping_status: this.props.housekeeping_status
        ? this.props.housekeeping_status
        : "disabled",
      type_of_booking: this.props.type_of_booking
        ? this.props.type_of_booking
        : "room",
      maximum_occupancy: this.props.maximum_occupancy
        ? this.props.maximum_occupancy
        : 0,
      max_error: [],
      /* generate check lists */
      all_property_types:
        this.props.all_property_types && this.props.all_property_types.length
          ? this.props.all_property_types
          : [],
      all_rooms:
        this.props.all_rooms && this.props.all_rooms.length
          ? this.props.all_rooms
          : [],
      all_room_groups:
        this.props.all_room_groups && this.props.all_room_groups.length
          ? this.props.all_room_groups
          : [],
      all_room_types:
        this.props.all_room_types && this.props.all_room_types.length
          ? this.props.all_room_types
          : [],
      all_rates:
        this.props.all_rates && this.props.all_rates.length
          ? this.props.all_rates
          : [],
      all_bedrooms:
        this.props.all_bedrooms && this.props.all_bedrooms.length
          ? this.props.all_bedrooms
          : [],
      all_products:
        this.props.all_products && this.props.all_products.length
          ? this.props.all_products
          : [],

      /* associations */
      // amenities: this.props.amenities,
      room_type_id: this.props.id ? this.props.id : "-0",
      ru_amenities: this.props.ru_amenities,
      ru_amenity_ids: this.props.ru_amenity_ids,
      categories: this.props.categories,
      rooms: rooms,
      room_groups: room_groups,
      rates: rates,
      bedrooms: bedrooms,
      products: products,
      property: property,
      image_group_ids: image_group_ids,
      image_group: this.props.image_group ? this.props.image_group : null,
      images_data_table_path: this.props.images_data_table_path || null,
      incidental_deposit: this.props.incidental_deposit
        ? this.props.incidental_deposit
        : null,
      room_type_prices: room_type_prices,
      room_type_housekeeping_types: this.props.room_type_housekeeping_types
        ? this.props.room_type_housekeeping_types
        : [],
      all_properties: this.props.all_properties || [],

      /* helpers */
      date_format: this.props.date_format,
      time_format: this.props.time_format,
      is_new: this.props.is_new,
      ota_property_type: this.props.ota_property_type
        ? this.props.ota_property_type
        : "",
      ru_rate: this.props.ru_rate ? this.props.ru_rate : null,
      ru_active: this.props.ru_active ? "enabled" : "disabled",
      bathroom_count: this.props.bathroom_count,
      floor: this.props.floor,
      ru_redirect_url: this.props.ru_redirect_url
    };

    this.setActiveTab = this.setActiveTab.bind(this);
    this.onFieldChange = this.onFieldChange.bind(this);
    this.onColorChange = this.onColorChange.bind(this);
    this.onChangeAmenities = this.onChangeAmenities.bind(this);
    this.onAddAmenity = this.onAddAmenity.bind(this);
    this.onChangeIncidentalDeposit = this.onChangeIncidentalDeposit.bind(this);
    this.onChangePrice = this.onChangePrice.bind(this);
    this.onChangeRooms = this.onChangeRooms.bind(this);
    this.onChangeBedrooms = this.onChangeBedrooms.bind(this);
    this.onChangeRoomGroups = this.onChangeRoomGroups.bind(this);
    this.onChangeHousekeepingTypes = this.onChangeHousekeepingTypes.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onImageChange = this.onImageChange.bind(this);
    this.prepParams = this.prepParams.bind(this);
    this.onChangeProperty = this.onChangeProperty.bind(this);
    this.onChangePropertyType = this.onChangePropertyType.bind(this);
    this.onChangeAllDays = this.onChangeAllDays.bind(this);
    this.onChangeAllMinimumStays = this.onChangeAllMinimumStays.bind(this);
    this.onChangeOrder = this.onChangeOrder.bind(this);
    this.onChangeAmenityOrder = this.onChangeAmenityOrder.bind(this);
    this.onChangeRates = this.onChangeRates.bind(this);
    this.onChangeProducts = this.onChangeProducts.bind(this);
    this.onChangeRoomTypePrices = this.onChangeRoomTypePrices.bind(this);
  }

  render() {
    var buttons = [
      {
        name: I18n.t("cancel"),
        html_attributes: ['data-dismiss="modal"'],
      },
      {
        name: I18n.t("submit"),
        button_classes: ["primary"],
        onClick: this.onSubmit,
      },
    ];

    return (
      <div className="RoomTypeBuilder">

        <Tabs
          tabs={this.tabs()}
          displayErrorMessage={
            RoomTypeBuilderErrors.general(this.state.errors).length ||
            RoomTypeBuilderErrors.incidental_deposit(this.state.errors)
              .length ||
            RoomTypeBuilderErrors.rooms(this.state.errors).length ||
            RoomTypeBuilderErrors.room_groups(this.state.errors).length ||
            RoomTypeBuilderErrors.price(this.state.errors).length ||
            RoomTypeBuilderErrors.housekeeping_types(this.state.errors).length ||
            RoomTypeBuilderErrors.channels(this.state.errors).length
              ? true
              : false
          }
        />
        <div className="panel panel-form">
          <ModalButtons loading={this.state.loading} buttons={buttons} />
          <RoomTypeBuilderWorkspace
            {...this.state}
            ru_id={this.props.ru_id}
            ota_property_types={this.props.ota_property_types}
            onFieldChange={this.onFieldChange}
            onColorChange={this.onColorChange}
            onChangeAmenities={this.onChangeAmenities}
            onAddAmenity={this.onAddAmenity}
            onRemoveAmenity={this.onRemoveAmenity}
            onChangeCategories={this.onChangeCategories}
            onChangeIncidentalDeposit={this.onChangeIncidentalDeposit}
            onChangePrice={this.onChangePrice}
            onChangeRooms={this.onChangeRooms}
            onChangeBedrooms={this.onChangeBedrooms}
            onChangeRoomGroups={this.onChangeRoomGroups}
            onChangeHousekeepingTypes={this.onChangeHousekeepingTypes}
            onImageChange={this.onImageChange}
            onChangeProperty={this.onChangeProperty}
            onChangeAllDays={this.onChangeAllDays}
            onChangeAllMinimumStays={this.onChangeAllMinimumStays}
            onChangeOrder={this.onChangeOrder}
            onChangeAmenityOrder={this.onChangeAmenityOrder}
            onChangeRates={this.onChangeRates}
            onChangeProducts={this.onChangeProducts}
            onChangeRoomTypePrices={this.onChangeRoomTypePrices}
            onChange={this.onChange}
            onChangePropertyType={this.onChangePropertyType}
            beds_types={this.props.beds_types}
            image_types={this.props.image_types}
            onChangeImageType={this.onChangeImageType}
            ru_rates_path={this.props.ru_rates_path}
            max_property_ru_activated={this.props.max_property_ru_activated}
            ordered_bed_types={this.props.ordered_bed_types}
            changeBedType={this.changeBedType}
            changeBedCount={this.changeBedCount}
            onGeoSelectAddress={this.onGeoSelectAddress}
          />
        </div>
        <LoadingSpinner show={this.state.loading} />
      </div>
    );
  }

  tabs() {
    var tabs = [];

    tabs.push({
      tabName: I18n.t("general"),
      targetName: "general",
      classes: this.state.active_tab === "general" ? "active" : null,
      changeHandler: this.setActiveTab,
      tabErrorCount: RoomTypeBuilderErrors.general(this.state.errors).length,
    });

    tabs.push({
      tabName: I18n.t("amenities"),
      targetName: "amenities",
      classes: this.state.active_tab === "amenities" ? "active" : null,
      changeHandler: this.setActiveTab,
    });

    tabs.push({
      tabName: I18n.t("images"),
      targetName: "images",
      classes: this.state.active_tab === "images" ? "active" : null,
      changeHandler: this.setActiveTab,
      tabErrorCount: ErrorHelper.tabErrorCount(this.state.errors, [
        "images",
        "image_description",
      ]),
    });

    tabs.push({
      tabName: I18n.t("incidental_deposit"),
      targetName: "incidental_deposit",
      classes: this.state.active_tab === "incidental_deposit" ? "active" : null,
      changeHandler: this.setActiveTab,
      tabErrorCount: RoomTypeBuilderErrors.incidental_deposit(this.state.errors)
        .length,
    });

    tabs.push({
      tabName: I18n.t("base_prices"),
      targetName: "price",
      classes: this.state.active_tab === "price" ? "active" : null,
      changeHandler: this.setActiveTab,
      tabErrorCount: RoomTypeBuilderErrors.price(this.state.errors).length,
    });

    tabs.push({
      tabName: I18n.t("rates"),
      targetName: "rates",
      classes: this.state.active_tab === "rates" ? "active" : null,
      changeHandler: this.setActiveTab,
    });

    if (this.state.type_of_booking != "daily") {
      tabs.push({
        tabName: I18n.t("products"),
        targetName: "products",
        classes: this.state.active_tab === "products" ? "active" : null,
        changeHandler: this.setActiveTab,
      });
    }
    

    if (this.state.type_of_booking == "room_group") {
      tabs.push({
        tabName: I18n.t("room_groups"),
        targetName: "room_groups",
        classes: this.state.active_tab === "room_groups" ? "active" : null,
        changeHandler: this.setActiveTab,
        tabErrorCount: RoomTypeBuilderErrors.room_groups(this.state.errors)
          .length,
      });
    } else {
      tabs.push({
        tabName: I18n.t("rooms"),
        targetName: "rooms",
        classes: this.state.active_tab === "rooms" ? "active" : null,
        changeHandler: this.setActiveTab,
        tabErrorCount: RoomTypeBuilderErrors.rooms(this.state.errors).length,
      });
    }

    if (this.state.housekeeping_status == "enabled" && this.state.type_of_booking != "daily") {
      tabs.push({
        tabName: I18n.t("housekeeping_types"),
        targetName: "housekeeping_types",
        classes:
          this.state.active_tab === "housekeeping_types" ? "active" : null,
        changeHandler: this.setActiveTab,
        tabErrorCount: RoomTypeBuilderErrors.housekeeping_types(
          this.state.errors
        ).length,
      });
    }

    if (this.state.type_of_booking != "daily") {
      tabs.push({
        tabName: I18n.t("layout"),
        targetName: "layout",
        classes: this.state.active_tab === "layout" ? "active" : null,
        changeHandler: this.setActiveTab,
        tabErrorCount: RoomTypeBuilderErrors.bedrooms(this.state.errors).length,
      });
    }
    
    if (
      this.props.max_property_ru_activated &&
      this.state.ru_active == "enabled" &&
      this.state.type_of_booking != "daily"
    ) {
      tabs.push({
        tabName: I18n.t("channel_management"),
        targetName: "channel_management",
        classes:
          this.state.active_tab === "channel_management" ? "active" : null,
        changeHandler: this.setActiveTab,
        tabErrorCount: RoomTypeBuilderErrors.channels(this.state.errors).length,
      });
    }

    return tabs;
  }

  onSubmit() {
    var self = this;
    var params = this.prepParams();
    self.setState({ loading: true });
    setTimeout(function () {
      $.ajax({
        type: "POST",
        url: self.state.is_new
          ? self.state.room_type_create_path
          : self.state.room_type_save_path,
        data: params,
      }).done(function (data) {
        if (Object.keys(data.errors).length) {
          self.setState({
            errors: data.errors,
          });
          self.setState({ loading: false });
        } else {
          self.setState({ loading: false });
          window.parent.$(window.parent).trigger("folioItemSavedSuccessfully");
          if (parent && parent.refresh_data) {
            if (self.props.is_new == true) {
              parent.refresh_data(I18n.t("room_type_created_successfully"));
            } else {
              parent.refresh_data(I18n.t("room_type_saved_successfully"));
            }
          }
          if (parent && parent.hide_modal) {
            parent.hide_modal();
          }
        }
      });
    }, 1000);
  }

  prepParams() {
    return {
      room_type: {
        code: this.state.code,
        name: this.state.name,
        status: this.state.status,
        housekeeping_status: this.state.housekeeping_status,
        type_of_booking: this.state.type_of_booking,
        description: this.state.description,
        room_size: this.state.room_size,
        room_size_unit: this.state.room_size_unit,
        maximum_occupancy: this.state.maximum_occupancy,
        days_before_arrival: this.state.days_before_arrival,
        how_to_arrive: this.state.how_to_arrive,
        space: this.state.space,
        access: this.state.access,
        interaction: this.state.interaction,
        house_rules: this.state.house_rules,
        address_1: this.state.address_1,
        address_2: this.state.address_2,
        city: this.state.city,
        state: this.state.state,
        country: this.state.country,
        postal_code: this.state.postal_code,
        licence_number: this.state.licence_number,
        bathroom_count: this.state.bathroom_count, 
        floor: this.state.floor, 
        
        color: this.state.color,
        incidental_deposit: this.state.incidental_deposit,
        image_group_id: this.state.image_group
          ? this.state.image_group.id
          : null,
        ota_property_type_id: this.state.ota_property_type,
        property_type_id: this.state.property_type_id,
        ru_active: this.state.ru_active == "enabled" ? true : false,
        ru_description: this.state.ru_description,
        ru_redirect_url: this.state.ru_redirect_url
      },
      room_type_prices: this.state.room_type_prices,
      // amenities: this.state.amenities.length
      //   ? this.state.amenities.map((amenity) => JSON.stringify(amenity))
      // room_type_price: this.state.room_type_price,
      amenities: this.state.ru_amenities.length
        ? this.state.ru_amenities.map((ru_amenity) =>
            JSON.stringify(ru_amenity)
          )
        : null,
      bed_types: this.state.bed_types.length
        ? this.state.bed_types.map((bt) => JSON.stringify(bt))
        : null,
      products: this.state.products,
      rates: this.state.rates,
      property: this.state.property,
      associated_rooms:
        this.state.type_of_booking == "room_group" ? null : this.state.rooms,
      associated_room_groups:
        this.state.type_of_booking == "room_group"
          ? this.state.room_groups
          : null,
      bedrooms: this.state.bedrooms,
      image_group_images_and_image_types: this.setImageGroupImages(),
      ru_rate_id: this.state.ru_rate ? this.state.ru_rate.id : null,
      // image_group_ids: this.state.image_group_ids,
      room_type_housekeeping_types: this.state.room_type_housekeeping_types,
    };
  }

  setImageGroupImages = () => {
    return this.state.image_group_ids.map((imageId) => {
      return JSON.stringify({
        image_id: imageId,
        image_type_id: this.state.image_group.images.find(
          (image) => image.id == imageId
        ).image_type_id,
      });
    });
  };

  setActiveTab(tab) {
    this.setState({
      active_tab: tab,
    });
  }

  onFieldChange(event, value) {
    if (event && event.target) {
      
      if (
        event.target.id === "housekeeping_status" &&
        event.target.value === "disabled"
      ) {
        this.setState({
          [event.target.id]: event.target.value,
          room_type_housekeeping_types: [],
        });
      } else if (event.target.name == "room_size" || event.target.name == "ru_redirect_url"){
        this.setState({
          [event.target.name]: event.target.value,
        });

      } else if (event.target.id == "type_of_booking" && event.target.value == 'room_group'){
        this.setState({
          [event.target.id]: event.target.value,
          ru_active: 'disabled',
          ru_rate: null,
        });
      } else {
        this.setState({
          [event.target.id]: event.target.value,
        });
      }
    } else {
      this.state[event] = value;
      this.setState(this.state);
    }
  }

  onColorChange(color) {
    this.setState({ color: color });
  }

  onChangeIncidentalDeposit(incidental_deposit) {
    this.setState({ incidental_deposit: incidental_deposit });
  }

  onChangeAmenities(e) {
    var id = null;
    var name = null;
    var otas = [];

    var checked = null;
    let ru_amenities = [];

    if (e.target) {
      id = e.target.id;
      name = e.target.dataset.amenity;
      otas = e.target.dataset.otas.split(',');
      checked = e.target.checked;
    }

    if (checked == false) {
      ru_amenities = this.state.ru_amenities.filter((selectedAmenity) => {
        if (selectedAmenity.id != e.target.id) {
          return selectedAmenity;
        }
      });
    } else {
      ru_amenities = [...this.state.ru_amenities, { id: id, name: name, otas: otas, count: 1 }];
    }

    this.setState({ ru_amenities: ru_amenities });
  }

  onAddAmenity(amenity) {
    amenity.count = 1;
    this.setState({ ru_amenities: [...this.state.ru_amenities, amenity], ru_amenity_ids: [...this.state.ru_amenity_ids, amenity.id] });
  }

  onRemoveAmenity = (e) => {
    let ru_amenities = this.state.ru_amenities.filter((selectedAmenity) => {
      if (selectedAmenity.id != e.target.id) {
        return selectedAmenity;
      }
    });

    this.setState({ ru_amenities: ru_amenities });
  };

  onChangeRates(rates) {
    this.setState({ rates: rates });
  }

  onChangeProducts(products) {
    this.setState({ products: products });
  }

  onImageChange(image_group) {
    var image_group_ids = image_group.images.map((image) => image.id);
    if (image_group) {
      this.setState({
        image_group_ids: image_group_ids,
        image_group: image_group,
      });
    } else {
      this.setState({
        image_group_ids: null,
        image_group: null,
      });
    }
  }

  onChangeAmenityOrder(idsInOrder) {
    var ru_amenities = [...this.state.ru_amenities];
    var ru_amenities_new = [];

    idsInOrder.map((id, idx) => {
      var ru_amenity = ru_amenities.find((ru_amenity) => ru_amenity.id == id);
      ru_amenity["position"] = idx;
      ru_amenities_new.push(ru_amenity);
    });
    this.setState({
      ru_amenity_ids: idsInOrder,
      ru_amenities: ru_amenities_new,
    });
  }

  onChangeOrder(idsInOrder) {
    this.setState({ image_group_ids: idsInOrder });
  }

  onChangeImageType = (e) => {
    let imageGroup = { ...this.state.image_group };
    imageGroup.images.find((image) => image.id == e.target.id).image_type_id =
      e.target.value;
    this.setState({ image_group: imageGroup });
  };

  onChangePrice(prices) {
    var room_type_price = { ...prices };
    delete room_type_price.active_tab;
    delete room_type_price.errors;
    delete room_type_price.tabs;
    delete room_type_price.nested;
    delete room_type_price.loading;
    delete room_type_price.seasonal_prices;
    delete room_type_price.additional_guest_amount;
    delete room_type_price.guests_included;
    delete room_type_price.max_guests_allowed;
    delete room_type_price.room_type;
    delete room_type_price.updated_at;

    if (prices) {
      this.setState({ room_type_price: room_type_price });
    } else {
      this.setState({ room_type_price: null });
    }
  }

  onChangeRooms(selected_rooms) {
    this.setState({ rooms: selected_rooms });
  }

  onChangeRoomTypePrices(room_type_prices) {
    this.setState({ room_type_prices: room_type_prices });
  }

  onChangePropertyType(event) {
    this.setState({ property_type_id: event.target.value });
  }

  onChangeBedrooms(selected_bedrooms) {
    this.setState({ bedrooms: selected_bedrooms });
  }

  onChangeRoomGroups(selected_rooms) {
    this.setState({ room_groups: selected_rooms });
  }

  onChangeProperty(event) {
    this.setState({
      property: event.target.value,
    });
  }

  onChangeHousekeepingTypes(event) {
    if (event && event.target) {
      this.setState({ room_type_housekeeping_types: event.target.value });
    }
  }

  onChangeAllDays(e) {
    var newPrices = this.state.room_type_price;
    newPrices.sunday_amount = e;
    newPrices.monday_amount = e;
    newPrices.tuesday_amount = e;
    newPrices.wednesday_amount = e;
    newPrices.thursday_amount = e;
    newPrices.friday_amount = e;
    newPrices.saturday_amount = e;
    this.setState({ room_type_price: newPrices });
  }

  onChangeAllMinimumStays(e) {
    var newMinimum = this.state.room_type_price;
    newMinimum.sunday_minimum_stay = e;
    newMinimum.monday_minimum_stay = e;
    newMinimum.tuesday_minimum_stay = e;
    newMinimum.wednesday_minimum_stay = e;
    newMinimum.thursday_minimum_stay = e;
    newMinimum.friday_minimum_stay = e;
    newMinimum.saturday_minimum_stay = e;
    this.setState({ room_type_price: newMinimum });
  }

  onChange = (e) => {
    if (e.target.name == "ru_amenity") {
      let ru_amenities = [...this.state.ru_amenities].map((ru_amenity) => {
        if (ru_amenity.id == e.target.id) {
          ru_amenity.count = e.target.value;
        }

        return ru_amenity;
      });

      this.setState({ ru_amenities: ru_amenities });
    } else {
      this.setState({ [e.target.name]: e.target.value });
    }
  };

  generateId() {
    var text = "";
    var possible = "0123456789";

    for (var i = 0; i < 9; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return '-' + text;
  }

  changeBedType = (e) => {
    let bedTypes = [...this.state.bed_types];

    if (e.target.checked) {
      bedTypes.push({ bed_type_id: e.target.id, count: 1 });
    } else {
      bedTypes = bedTypes.filter((bt) => bt.bed_type_id !== e.target.id);
    }

    this.setState({ bed_types: bedTypes });
  };

  changeBedCount = (e) => {
    let bedTypes = this.state.bed_types.map((bed_type) => {
      if (bed_type.bed_type_id == e.target.id) {
        bed_type.count = e.target.value;
      }

      return bed_type;
    });

    this.setState({ bed_types: bedTypes });
  };

  onGeoSelectAddress = (obj) => {
    this.setState(obj);
  };
};

export default RoomTypeBuilder;
